import { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import CompanyLogo1 from "../../assets/logos_parceiros/regina.png";
import CompanyLogo2 from "../../assets/logos_parceiros/panvel.png";
import CompanyLogo3 from "../../assets/logos_parceiros/centroeco.png";
import CompanyLogo4 from "../../assets/logos_parceiros/nap.png";
import CompanyLogo5 from "../../assets/logos_parceiros/emporio-gaia.png";
import CompanyLogo6 from "../../assets/logos_parceiros/exame.png";
import CompanyLogo7 from "../../assets/logos_parceiros/unimed.png";
import CompanyLogo8 from "../../assets/logos_parceiros/droga-raia.png";
import CompanyLogo9 from "../../assets/logos_parceiros/doctor-med.png";
import CompanyLogo10 from "../../assets/logos_parceiros/formula-bichos.png";
import CompanyLogo11 from "../../assets/logos_parceiros/adaptta.png";
import CompanyLogo12 from "../../assets/logos_parceiros/cfisio.png";
import CompanyLogo13 from "../../assets/logos_parceiros/hemovida.png";
import CompanyLogo14 from "../../assets/logos_parceiros/proscout.png";
import CompanyLogo15 from "../../assets/logos_parceiros/pet-store.png";
import CompanyLogo16 from "../../assets/logos_parceiros/fisiohaus.png";
import CompanyLogo17 from "../../assets/logos_parceiros/hospital-sapiranga.png";
import CompanyLogo18 from "../../assets/logos_parceiros/instituto-visao.png";
import CompanyLogo19 from "../../assets/logos_parceiros/nao-mais-pelo.png";
import CompanyLogo20 from "../../assets/logos_parceiros/oticas-carol.png";
import CompanyLogo21 from "../../assets/logos_parceiros/laboratorio-bio.png";
import CompanyLogo22 from "../../assets/logos_parceiros/maxxi-odonto.png";
import CompanyLogo23 from "../../assets/logos_parceiros/ponto-psi.png";
import CompanyLogo24 from "../../assets/logos_parceiros/qualita.png";
import CompanyLogo25 from "../../assets/logos_parceiros/uptime.png";
import CompanyLogo26 from "../../assets/logos_parceiros/sant.png";
import CompanyLogo27 from "../../assets/logos_parceiros/oticas-pisquey.png";
import CompanyLogo28 from "../../assets/logos_parceiros/servdonto.png";
import CompanyLogo29 from "../../assets/logos_parceiros/sos-kids.png";
import CompanyLogo30 from "../../assets/logos_parceiros/vida-e-saude.png";
import CompanyLogo31 from "../../assets/logos_parceiros/saintmichel.png";
import CompanyLogo32 from "../../assets/logos_parceiros/strapacao.png";
import CompanyLogo33 from "../../assets/logos_parceiros/upa-vet.png";
import CompanyLogo34 from "../../assets/logos_parceiros/vic-center.png";
import CompanyLogo35 from "../../assets/logos_parceiros/cia-do-corpo.png";
import CompanyLogo36 from "../../assets/logos_parceiros/sao-jose.png";
import CompanyLogo37 from "../../assets/logos_parceiros/matriz.png";
import CompanyLogo38 from "../../assets/logos_parceiros/fleming.png";
import CompanyLogo39 from "../../assets/logos_parceiros/tecnolar.png";
import CompanyLogo40 from "../../assets/logos_parceiros/intensidade.png";
import CompanyLogo41 from "../../assets/logos_parceiros/weinmann.png";
import CompanyLogo42 from "../../assets/logos_parceiros/serdil.png";
import CompanyLogo43 from "../../assets/logos_parceiros/oticas-corujinha.png";
import CompanyLogo44 from "../../assets/logos_parceiros/clinica-visao.png";
import CompanyLogo45 from "../../assets/logos_parceiros/uniao-pet-center.png";
import "./AutoPlayCarousel.css";

export default function AutoPlayCarousel() {
  const [cardDetails, setCardDetails] = useState({
    0: {
      imgUrl: CompanyLogo1,
      title: "Hospital Regina",
    },
    1: {
      imgUrl: CompanyLogo2,
      title: "Panvel",
    },
    2: {
      imgUrl: CompanyLogo3,
      title: "Centro Eco",
    },
    3: {
      imgUrl: CompanyLogo4,
      title: "NAP",
    },
    4: {
      imgUrl: CompanyLogo5,
      title: "Emporio Gaia",
    },
    5: {
      imgUrl: CompanyLogo6,
      title: "Exame",
    },
    6: {
      imgUrl: CompanyLogo7,
      title: "Unimed",
    },
    7: {
      imgUrl: CompanyLogo8,
      title: "Droga Raia",
    },
    8: {
      imgUrl: CompanyLogo9,
      title: "Doctor Med",
    },
    9: {
      imgUrl: CompanyLogo10,
      title: "Fórmula Bichos",
    },
    10: {
      imgUrl: CompanyLogo11,
      title: "Pet Store",
    },
    11: {
      imgUrl: CompanyLogo12,
      title: "Adaptta",
    },
    12: {
      imgUrl: CompanyLogo13,
      title: "Cfisio",
    },
    13: {
      imgUrl: CompanyLogo14,
      title: "Hemovida",
    },
    14: {
      imgUrl: CompanyLogo15,
      title: "Proscout",
    },
    15: {
      imgUrl: CompanyLogo16,
      title: "Fisiohaus",
    },
    16: {
      imgUrl: CompanyLogo17,
      title: "Hospital Sapiranga",
    },
    17: {
      imgUrl: CompanyLogo18,
      title: "Instituto Visão",
    },
    18: {
      imgUrl: CompanyLogo19,
      title: "Não + Pelo",
    },
    19: {
      imgUrl: CompanyLogo20,
      title: "Óticas Carol",
    },
    20: {
      imgUrl: CompanyLogo21,
      title: "Laboratório Bio",
    },
    21: {
      imgUrl: CompanyLogo22,
      title: "Maxxi Odonto",
    },
    22: {
      imgUrl: CompanyLogo23,
      title: "Ponto Psi",
    },
    23: {
      imgUrl: CompanyLogo24,
      title: "Qualitá",
    },
    24: {
      imgUrl: CompanyLogo25,
      title: "Uptime",
    },
    25: {
      imgUrl: CompanyLogo44,
      title: "Clínica Visão",
    },
    26: {
      imgUrl: CompanyLogo27,
      title: "Oticas Pisquey",
    },
    27: {
      imgUrl: CompanyLogo28,
      title: "Servdonto",
    },
    28: {
      imgUrl: CompanyLogo41,
      title: "Weinmann",
    },
    29: {
      imgUrl: CompanyLogo45,
      title: "União Pet Center",
    },
    30: {
      imgUrl: CompanyLogo43,
      title: "Corujinha",
    },
    31: {
      imgUrl: CompanyLogo32,
      title: "Strapação",
    },
    32: {
      imgUrl: CompanyLogo33,
      title: "UPA Vet",
    },
    33: {
      imgUrl: CompanyLogo34,
      title: "Vic Center",
    },
    34: {
      imgUrl: CompanyLogo35,
      title: "Cia do Corpo",
    },
    35: {
      imgUrl: CompanyLogo36,
      title: "São José",
    },
    36: {
      imgUrl: CompanyLogo37,
      title: "Matriz",
    },
    37: {
      imgUrl: CompanyLogo38,
      title: "Fleming",
    },
    38: {
      imgUrl: CompanyLogo39,
      title: "Tecnolar",
    },
    39: {
      imgUrl: CompanyLogo40,
      title: "Intensidade",
    },
    40: {
      imgUrl: CompanyLogo29,
      title: "SOS Kids",
    },
    41: {
      imgUrl: CompanyLogo42,
      title: "Serdil",
    },
    42: {
      imgUrl: CompanyLogo31,
      title: "Saint Michel",
    },
    43: {
      imgUrl: CompanyLogo26,
      title: "Sant",
    },
    44: {
      imgUrl: CompanyLogo30,
      title: "Vida e Saúde",
    },
  });

  return (
    <Container fluid className="autoplay-carousel-container">
      <div className="autoplay-carousel-track">
        {Object.keys(cardDetails).map((detailKey) => {
          return (
            <div key={detailKey} className="autoplay-carousel-card">
              <img
                src={cardDetails[detailKey].imgUrl}
                alt={cardDetails[detailKey].title}
              />
            </div>
          );
        })}
      </div>
    </Container>
  );
}
